import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="mb-16" data-id="element-26">
      <div className="bg-white rounded-3xl shadow-lg border-2 border-[#c9a24b] p-8 md:p-10 flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-27">
        <div className="shrink-0" data-id="element-28">
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-full bg-[#fdf8f5] border-4 border-[#c9a24b] flex flex-col items-center justify-center text-[#5d4a6e]" data-id="element-29">
            <ShieldCheck size={40} className="text-[#c08a92] mb-1" data-id="element-30" />
            <span className="font-black text-2xl leading-none" data-id="element-31">14</span>
            <span className="text-[10px] font-bold uppercase tracking-widest" data-id="element-32">
              Días
            </span>
          </div>
        </div>
        <div data-id="element-33">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#5d4a6e] mb-3" data-id="element-34">
            Garantía de satisfacción de 14 días
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-35">
            Quiero que empieces con total tranquilidad. Prueba el{' '}
            <span className="font-bold text-[#5d4a6e]" data-id="element-36">
              Kit de Reseteo Emocional™
            </span>{' '}
            durante 14 días. Si sientes que no es para ti, escríbenos y te
            devolvemos el 100% de tu inversión.{' '}
            <span className="bg-[#fdf8f5] text-[#c08a92] font-bold px-1 rounded" data-id="element-37">
              Sin preguntas incómodas.
            </span>{' '}
            El único riesgo es quedarte exactamente donde estás hoy.
          </p>
        </div>
      </div>
    </section>;
}